(function ($){

    $(function (){
        var $submit = $('.mod-publivate-categories form');

        $('.mod-publivate-categories form input[type="checkbox"]').on('click', function (e){
            $submit.submit();
        });
    });
})(jQuery);